import * as angular from "angular";
import {IController, IQService} from "angular";

export class tagSelectCtrl implements IController {

  selectedName: any;
  type: any;
  noUnderline: boolean;
  ngPlaceholder: string;
  onChange: Function;

  private tagsRef: any;
  private tagsList: any;
  private searchTerm: string;
  private loaded: boolean;

  /* @ngInject */
  constructor(private $tags, private $mdSelect, private $log, private $q: IQService) {
  }

  $onInit() {
    this.tagsRef = this.$tags();
    this.tagsList = [];
    this.searchTerm = '';
    this.loaded = false;

    if (this.selectedName) {
      this._getTags();
    }
  }

  onOpen() {
    return !this.loaded ? this._getTags() : this.$q.when();
  }

  cancel() {
    this.$mdSelect.hide();
  }

  select() {
    this.searchTerm = '';
    this.$mdSelect.hide();
  }

  _getTags() {
    const query = {
      type: this.type
    }

    return this.tagsRef.$getAll(query)
      .then((tagIds) => {
        return this.tagsRef.$asyncValues(tagIds);
      })
      .then((tags) => {
        this.tagsList = tags;
        this.loaded = true;
      })
      .catch((error) => {
        this.$log.error('Failed to get tags @tagSelectCtrl@_getTags', error);
      });
  }
}

angular
  .module('bringoz.admin.tags')
  .component('tagSelect', {
    bindings: {
      selectedName: '<',
      type: '<?',
      noUnderline: '@?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./tag-select.html').default,
    controller: tagSelectCtrl
  });
